// extracted by mini-css-extract-plugin
export var baseButton = "_po-0";
export var controlsArrowKeys = "_po-1";
export var controlsResetButton = "_po-2";
export var lightGameButton = "_po-4 _po-0";
export var playAgainButton = "_po-5 _po-0";
export var startGameButton = "_po-3 _po-0";